import { render, staticRenderFns } from "./ValidationDialog.vue?vue&type=template&id=a587f45a&scoped=true"
import script from "./ValidationDialog.vue?vue&type=script&lang=js"
export * from "./ValidationDialog.vue?vue&type=script&lang=js"
import style0 from "./ValidationDialog.vue?vue&type=style&index=0&id=a587f45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a587f45a",
  null
  
)

export default component.exports